import {
  COMPANY_GROUP_COMPANIES_SET_LOADING,
  COMPANY_GROUP_COMPANIES_SET_ERROR,
  COMPANY_GROUP_COMPANIES_SET_GROUPS,
  COMPANY_GROUP_COMPANIES_FETCH_GROUPS,
  COMPANY_GROUP_COMPANIES_GET_GROUPS,
  COMPANY_GROUP_COMPANIES_GET_LOADING,
  COMPANY_GROUP_COMPANIES_GET_ERROR
} from './types';
import { groupCompanyService } from '@/network';

const state = {
  groups: [],
  loading: false,
  error: null
};

const mutations = {
  [COMPANY_GROUP_COMPANIES_SET_LOADING](state, value) {
    state.loading = value;
  },
  [COMPANY_GROUP_COMPANIES_SET_ERROR](state, error) {
    state.error = error;
  },
  [COMPANY_GROUP_COMPANIES_SET_GROUPS](state, groups) {
    state.groups = groups;
  }
};

const actions = {
  async [COMPANY_GROUP_COMPANIES_FETCH_GROUPS]({ commit }, { companyId }) {
    commit(COMPANY_GROUP_COMPANIES_SET_LOADING, true);
    try {
      const groups = await groupCompanyService.getGroupCompanies({
        companyId
      });
      commit(COMPANY_GROUP_COMPANIES_SET_GROUPS, groups);
      commit(COMPANY_GROUP_COMPANIES_SET_ERROR, null);
    } catch (err) {
      const msg =
        err.response?.data?.message ||
        'Ocurrió un error al obtener los grupos de la empresa';
      console.error(err);
      commit(COMPANY_GROUP_COMPANIES_SET_ERROR, msg);
    } finally {
      commit(COMPANY_GROUP_COMPANIES_SET_LOADING, false);
    }
  }
};

const getters = {
  [COMPANY_GROUP_COMPANIES_GET_GROUPS]: (state) => state.groups,
  [COMPANY_GROUP_COMPANIES_GET_LOADING]: (state) => state.loading,
  [COMPANY_GROUP_COMPANIES_GET_ERROR]: (state) => state.error
};

export default {
  state,
  mutations,
  actions,
  getters
};
